import { ACTION_TYPE } from '../../core/redux/actionType';
import { IAppState } from '../../core/redux/IAppState';
import { Action } from 'redux';
import { assoc } from '../../language/module';


export const inactivityReducer = (state: IAppState, action: Action): IAppState => {
  if (action.type === ACTION_TYPE.LOGOUT || action.type === ACTION_TYPE.SHOW_SNACKBAR) {
    return state;
  }

  return assoc('lastActivity', new Date(), state);
};
